'use client'

import { useActionState, useEffect, useRef } from 'react'

interface UseFormActionOptions<T> {
  onSuccess?: (data: T) => void
  onError?: (error: string) => void
  resetOnSuccess?: boolean
}

export function useFormAction<T>(
  action: (state: any, formData: FormData) => Promise<any>,
  options: UseFormActionOptions<T> = {}
) {
  const { onSuccess, onError, resetOnSuccess = false } = options
  const formRef = useRef<HTMLFormElement>(null)
  const [state, formAction, isPending] = useActionState(action, null)

  useEffect(() => {
    if (state?.success) {
      onSuccess?.(state.data)
      if (resetOnSuccess && formRef.current) {
        formRef.current.reset()
      }
    }
    if (state?.error || state?.message) {
      onError?.(state.error || state.message)
    }
  }, [state, onSuccess, onError, resetOnSuccess])

  return {
    state,
    formAction,
    isPending,
    formRef,
    isSuccess: state?.success === true,
    isError: state?.success === false,
    errors: state?.errors,
  }
}
